import React, { useEffect, useRef, useState } from "react";
import "../styles/ScreenEventPlaylistModule.css";
import { TimePicker, Space, Row, Col, Popover, Tag, Modal, Badge } from "antd";
import {
  CloseCircleFilled,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import ScreenEventPlaylistModuleEditor from "./ScreenEventPlaylistModuleEditor";
import moment from "moment";
import Colors from "../config/Colors";
const { RangePicker } = TimePicker;
const weekdays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
const weekdayNums = [1, 2, 3, 4, 5, 6, 0];

function ScreenEventPlaylistModuleItem(props) {
  const [screenEventData, setScreenEventData] = useState(null);
  const [displayTimes, setDisplayTimes] = useState("No Specific Time");
  const [displayDates, setDisplayDates] = useState("No Specific Dates");
  const [editorVisible, setEditorVisible] = useState(false);
  const {
    onRemove = () => {},
    data,
    eventTypesData = [],
    onSave = () => {},
    screenData,
  } = props;
  const editorRef = useRef();
  const inputDateformat = "YYYY-MM-DD";
  const dateFormat = "DD-MM-YYYY";
  const inputformat = "HH:mm:ss";
  const format = "HH:mm";

  const { confirm } = Modal;

  useEffect(() => {
    if (props.data) {
      setScreenEventData(props.data);
    }
  }, []);

  useEffect(() => {
    if (!screenEventData) return;
    var time = `${new moment(screenEventData.StartTime, inputformat).format(format)} - ${new moment(screenEventData.EndTime, inputformat).format(format)}`;
    // var days = `${screenEventData.StartDate} - ${screenEventData.EndDate}`
    var days = `${new moment(screenEventData.StartDate, inputDateformat).format(dateFormat)} - ${new moment(screenEventData.EndDate, inputDateformat).format(dateFormat)}`;

    if (
      (screenEventData.StartTime === "00:00:00" &&
        screenEventData.EndTime === "23:59:59") ||
      (screenEventData.StartTime === "" && screenEventData.EndTime === "")
    ) {
      time = "No Specific Time";
    }
    if (screenEventData.StartDate === "" && screenEventData.EndDate === "") {
      days = "No Specific Dates";
    }

    setDisplayTimes(time);
    setDisplayDates(days);
  }, [screenEventData]);

  const showConfirm = (
    message = "Do you want to delete this data?",
    callback,
  ) => {
    confirm({
      title: message,
      icon: <ExclamationCircleOutlined />,
      onOk() {
        callback();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleVisibleChanged = (visible) => {
    setEditorVisible(visible);
    if (!visible) {
      if (editorRef.current) {
        editorRef.current.resetUnsavedChanged();
      }
    }
  };

  const onWeekdayScheduleSaved = (newData) => {
    setScreenEventData(newData);
    setEditorVisible(false);
    onSave(newData);
  };

  if (!screenEventData) {
    return null;
  }

  const eType = eventTypesData.find((e) => {
    return e.EventTypeID === screenEventData.EventTypeID;
  });

  return (
    <Badge.Ribbon
      placement="start"
      color={Colors.lightgray}
      text={`P${screenEventData.Priority}`}
    >
      <div
        className="itemrow"
        style={{ position: "relative", paddingLeft: "20px" }}
      >
        {/* <Badge.Ribbon text="Motion" color={Colors.purple} placement="start"> */}
        <Popover
          onOpenChange={handleVisibleChanged}
          placement="bottom"
          trigger="click"
          open={editorVisible}
          destroyTooltipOnHide
          content={
            <ScreenEventPlaylistModuleEditor
              ref={editorRef}
              eventTypes={eventTypesData}
              screenData={screenData}
              data={screenEventData}
              onSave={onWeekdayScheduleSaved}
            ></ScreenEventPlaylistModuleEditor>
          }
        >
          <div className="scheduletext scheduler">
            <Row>
              <Col flex={1} style={{}}>
                <div
                  style={{
                    padding: "10px",
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <Row>
                    {/* <Col span={4} style={{}}>
                                        <Tag color={Colors.blue}>Motion</Tag>
                                    </Col> */}
                    <Col span={20} style={{}}>
                      <Tag color={eType.EventTypeColor}>
                        {eType.EventTypeName}
                      </Tag>
                      {screenEventData.EventPlaylistName}
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* <Col style={{}}>
                            <div style={{ padding: "10px", display: "flex", alignItems: "center", width: "100%", height: "100%" }}>
                                <div className="schedulerow">
                                    <div className="labelgroup">
                                        {weekdays.map((day, index) => {

                                            const isActive = screenEventData.WeekDay.indexOf(`${weekdayNums[index]}`) !== -1
                                            const style = isActive ? "ui mini active label" : "ui mini label"
                                            return < div className={style}> {day.charAt(0)}</div>
                                        })}
                                    </div>
                                </div>

                                <div>
                                    <Row gutter={16} justify="space-between" style={{ padding: "0 10px", fontSize: "12px" }}>
                                        <Col>
                                            <Space align="start"><ClockCircleOutlined />{displayTimes}</Space>
                                        </Col>
                                        <Col>
                                            <Space align="end"><CalendarOutlined />{displayDates}</Space>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col> */}
            </Row>
          </div>
        </Popover>
        {/* </Badge.Ribbon> */}
        <div
          onClick={(e) => {
            showConfirm(
              `Do you want to remove the event '${screenEventData.EventPlaylistName}' from this screen?`,
              () => {
                onRemove(e);
              },
            );
            e.preventDefault();
          }}
          className="btn-remove-item"
          style={{ position: "absolute", right: "-24px", top: 0 }}
        >
          <CloseCircleFilled
            style={{
              color: "rgb(221, 221, 221)",
              cursor: "pointer",
              fontSize: "20px",
            }}
          />
        </div>
      </div>
    </Badge.Ribbon>
  );
}

export default ScreenEventPlaylistModuleItem;
